import { render } from "./AddSections.vue?vue&type=template&id=0756b226&scoped=true"
import script from "./AddSections.vue?vue&type=script&lang=js"
export * from "./AddSections.vue?vue&type=script&lang=js"

import "./AddSections.vue?vue&type=style&index=0&id=0756b226&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0756b226"

export default script